import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';


/**
 * API for managing workflow information
 */
const create = () => {  
    
    const api = BaseApi.create();
    
    const getCaseSettings = (taxYear) => api.getWithPayload(ApiPaths.CASE_STATE_SETTINGS, {taxYear});
    const setCaseSettings = (taxYear, settingName, settingValue) => {
        var payload = {
            taxYear,
            settingName,
            settingValue
        }
        return api.post(ApiPaths.CASE_STATE_SETTINGS, payload);
    }
    const getWorkflowState = (synchronize) => api.get(ApiPaths.CASE_STATE_SYNCHRONIZE(synchronize));
    const createNewCases = (action, assignment) => {
        var payload = {
            taxYears: action.taxYears,
            directCode: localStorage.getItem('va_direct_code'),
            associateId: (assignment || {}).associateId,
            officeId: (assignment || {}).officeId
        }
        return api.post(ApiPaths.CASE, payload);
    }
    const deleteCase = (taxYear) => api.deleteRequest(ApiPaths.DELETE_CASE(taxYear));
    const setLastReviewedPage = (action) => {
        var payload = {
            caseId: action.caseId,
            pageNumber: action.pageNumber
        }

        return api.post(ApiPaths.CASE_STATE_LAST_REVIEWED, payload);
    }
    const notifyOnScheduleCallAttempt = (taxYear) => {
        var payload = {
            taxYear: taxYear
        }

        return api.post(ApiPaths.CASE_STATE_NOTIFY_ON_SCHEDULE_CALL, payload);
    }
    const createDirectCode = (email, isNew) => {
        var payload = {
            email: email,
            isNew: !!isNew
        }

        return api.post(ApiPaths.DIRECT, payload);
    }
    const getDirectCodeConfig = () => api.get(ApiPaths.DIRECT);

    // Return back a collection of functions
    return {
        getCaseSettings, setCaseSettings,
        getWorkflowState, createNewCases, deleteCase, setLastReviewedPage,
        notifyOnScheduleCallAttempt, createDirectCode, getDirectCodeConfig
    }
}

// let's return back our create method as the default.
export default {
    create
}

